import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function InfoBox({classes=""}) {
  return (
    <>
     <style>{`
        .present_list { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 24px; }
        .present_box { padding: 20px; box-shadow: 0px 1px 3px rgba(18, 20, 32, 0.2); transition: all .3s; font-size: 16px; line-height: 1.4; color: #666; height: 100%; display: flex; flex-flow: column; align-items: self-start; min-height: 60px; padding-left: 120px; position: relative; border-radius: 16px; }
        .present_box:hover { box-shadow: 0px 16px 24px rgba(1, 6, 20, 0.1); }
        .present_icon { width: 80px; height: 80px; position: absolute; left: 20px; top: 20px; }
        .present_icon img { width: 100%; object-fit: contain; }
        .present_box h5 { font-size: 22px; margin-bottom: 10px; color: var(--dark); font-family: var(--bodyFont); font-weight: 600; }
        .present_item:last-child .present_box { background-color: var(--primary); color: #fff; padding: 20px; }
        .present_item:last-child .present_box h5 { color: #fff; }
        .present_box p { margin: 0; }
        .present_box .present_cta { margin-top: 12px; font-weight: 600; }
        .present_box .present_cta i { margin-left: 6px; transition: all .3s ease-in; }
        .present_box:hover .present_cta i { margin-left: 16px; }
        @media (max-width:991.98px) {
            .present_list { overflow-y: hidden; overflow-x: auto; width: calc(100% + 40px); margin-left: -20px; gap: 0; padding: 0 10px; scroll-snap-type: x mandatory; }
            .present_item { min-width: 340px; margin: 10px; scroll-snap-align: none center; }
            .section-padding.present_container { padding-top: 40px; }
            .present_box { box-shadow: 0px 1px 3px 1px rgba(18, 20, 32, 0.1) !important; }
            .present_list::-webkit-scrollbar { display: none; }
        }
        @media (max-width:767.98px) {
            .present_box p { width: 100%; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; font-size: 14px; line-height: 19px; }
            .present_box { justify-content: center; padding-left: 104px; }
            .present_item:last-child .present_box p { display: none; }
            .present_icon { width: 70px; height: 70px; top: 18px; left: 20px; }
            .present_box h5 { font-size: 20px; margin-bottom: 8px; }
            .present_item { min-width: 290px; }
        }`}
     </style>
    <div className={`section-padding present_container ${classes}`}>
    <Container>
        <Row data-aos="fade-up">
            <Col md={12}>
                <ul className="present_list d-grid flex-wrap">
                    <li className="present_item">
                        <div className="present_box">
                            <div className="present_icon">
                                <img src="../assets/images/home/it-expertise-icon.svg" alt="" />
                            </div>
                            <h5>IT Expertise</h5>
                            <p>Proficient in network admin, cybersecurity, cloud computing, programming, database management, troubleshooting, and IT project management.</p>
                        </div>
                    </li>
                    <li className="present_item">
                        <div className="present_box">
                            <div className="present_icon">
                                <img src="../assets/images/home/clock-clock-icon.svg" alt="" />
                            </div>
                            <h5>24/7 IT Support</h5>
                            <p>Rapid response to coding challenges, debugging, deployment issues, and ensuring continuous software functionality.</p>
                        </div>
                    </li>
                    <li className="present_item">
                        <a href='/contact/' className="present_box">
                            <h5>Custom Request</h5>
                            <p>Bespoke software development, network design, cybersecurity, and tech support for diverse business needs.</p>
                            <span className="present_cta">Find Solution  <i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                    </li>
                </ul>
            </Col>
        </Row>
    </Container>
    </div>
    </>
  )
}

export default InfoBox